var path = '/pages/guestlists/views/pages/rsvps/details/guests.tpl.html';
var html = "<div class=\"content-box\" ng-if=\"vm.loading\">\n    <al-loader size=\"medium\"></al-loader>\n</div>\n<rsvp-guests-full ng-if=\"!vm.loading\" rsvp=\"vm.rsvp\"></rsvp-guests-full>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/guestlists/views/pages/rsvps/details/guests.tpl.html
// module id = 2280
// module chunks = 1